import request from '@/common/request.js'

export default {
  // 统计学习时长
  addLessonVideoLookTime(studyDurationType, studyTime) {
    const data = {
      study_time: studyTime,
      study_duration_type: studyDurationType,
    }
    return request.post('/api/v2/member/incrUserStudyTime', data)
  },
}



// WEBPACK FOOTER //
// ./src/apis/member/member.js